import { type FileUIPart } from 'ai';

const OBJECT_URL_LIFETIME_MS = 60_000;

const isTextAttachment = (attachment: FileUIPart): boolean =>
  attachment.mediaType.startsWith('text/');

const toBlob = (attachment: FileUIPart): Blob => {
  const base64 = attachment.url.slice(attachment.url.indexOf(',') + 1);
  const bytes = Uint8Array.from(atob(base64), (char) => char.charCodeAt(0));
  const type = isTextAttachment(attachment)
    ? 'text/plain;charset=utf-8'
    : attachment.mediaType;

  return new Blob([bytes], { type });
};

/**
 * Opens a document attachment in a new tab, or downloads it when the browser
 * can't display the file type.
 */
export const openAttachment = (attachment: FileUIPart): void => {
  const url = URL.createObjectURL(toBlob(attachment));
  const canDisplay =
    attachment.mediaType === 'application/pdf' || isTextAttachment(attachment);

  if (canDisplay) {
    window.open(url, '_blank', 'noopener');
  } else {
    const link = document.createElement('a');
    link.href = url;
    link.download = attachment.filename ?? 'attachment';
    link.click();
  }

  // The new tab loads the URL after this returns.
  window.setTimeout(() => URL.revokeObjectURL(url), OBJECT_URL_LIFETIME_MS);
};
